export default "/images/a1f5d3d239c806723df1073f58556825.avif";